import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CardHeaderRegular from './CardHeaderRegular';
import CardHeaderChips from './CardHeaderChips';
import SecondaryButton from '../SecondaryButton';
import { useStyles } from './styles';

function CovidQuestionCard({
  id,
  srcImg,
  question,
  statusQuestion: { questionAnswered, answer },
  handleAnswerOnCheckCovidQuestion,
}) {
  const classes = useStyles();
  const { t } = useTranslation(['checkCovidScreen', 'button']);

  const handleClick = ({ id, answer }) => () => {
    handleAnswerOnCheckCovidQuestion({ id, answer });
  };

  return (
    <Paper className={classes.card}>
      {typeof srcImg === 'string' ? (
        <CardHeaderRegular srcImg={srcImg} question={question} />
      ) : (
        <CardHeaderChips symptomChipsList={srcImg} />
      )}
      <Box className={classes.buttonGroup}>
        <SecondaryButton
          cardId={id}
          leftButton
          actionButton="no"
          questionAnswered={questionAnswered}
          answer={answer}
          textButton={t('button:decline')}
          handleClick={handleClick}
        />
        <SecondaryButton
          cardId={id}
          actionButton="yes"
          questionAnswered={questionAnswered}
          answer={answer}
          textButton={t('button:confirm')}
          handleClick={handleClick}
        />
      </Box>
    </Paper>
  );
}

export default CovidQuestionCard;
